export function getTodayDate(): string {
    const now = new Date();

    const utcYear = now.getUTCFullYear();
    const utcMonth = String(now.getUTCMonth() + 1).padStart(2, "0");
    const utcDay = String(now.getUTCDate()).padStart(2, "0");
    const utcHours = String(now.getUTCHours()).padStart(2, "0");
    const utcMinutes = String(now.getUTCMinutes()).padStart(2, "0");

    const utcString = `${utcYear}-${utcMonth}-${utcDay}T${utcHours}:${utcMinutes}`;
    return utcString;
}

export function utcToLocalString(utcDateString?: string): string {
    if (!utcDateString) {
        console.warn("utcToLocalString: received undefined or empty string");
        return "";
    }

    const date = new Date(
        utcDateString.endsWith("Z") ? utcDateString : utcDateString + "Z"
    );

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes} ${day}/${month}/${year}`;
}
